import React from 'react';
import { Box } from '@mui/material';
import { keyframes } from '@mui/system';

import { SANS_STACK, TEXT_DARK } from '../common/tokens';

const fadeInUp = keyframes`
  from { opacity: 0; transform: translateY(8px); }
  to   { opacity: 1; transform: translateY(0); }
`;

// Renaming is a press-and-hold, which nothing on screen would otherwise suggest.
export default function HoldHint() {
  return (
    <Box sx={{
      position: 'absolute',
      bottom: 'calc(100% + 7px)',
      left: '50%',
      transform: 'translateX(-50%)',
      background: TEXT_DARK,
      color: '#fff',
      fontSize: 11,
      padding: '4px 8px',
      borderRadius: '4px',
      whiteSpace: 'nowrap',
      pointerEvents: 'none',
      fontFamily: SANS_STACK,
      animation: `${fadeInUp} 0.15s ease`,
      zIndex: 100,
    }}>
      Hold to rename
      <Box
        component="span"
        sx={{
          position: 'absolute',
          top: '100%',
          left: '50%',
          transform: 'translateX(-50%)',
          width: 0,
          height: 0,
          borderLeft: '4px solid transparent',
          borderRight: '4px solid transparent',
          borderTop: `4px solid ${TEXT_DARK}`,
        }}
      />
    </Box>
  );
}
